/* global Stripe, ApplePaySession */
const formatAmount = amount => `${Math.floor(amount / 100)}.${amount % 100}`;

const paymentRequest = (amount, currency) => ({
  countryCode: 'US',
  currencyCode: currency.toUpperCase(),
  total: {
    label: 'SQUIRE',
    amount: formatAmount(amount),
  },
  requiredShippingContactFields: [
    'name',
    'email',
    'phone',
  ],
});

export const mapApplePayUser = ({ givenName, familyName, phoneNumber, emailAddress }) => ({
  firstName: givenName,
  lastName: familyName,
  phone: phoneNumber,
  email: emailAddress,
});

export const applePaySession = (amount, currency, onSuccess, onError, onCancel) => {
  const session = Stripe.applePay.buildSession(
    paymentRequest(amount, currency),
    (result, completion) => onSuccess(result)
      .then(() => completion(ApplePaySession.STATUS_SUCCESS))
      .catch(() => completion(ApplePaySession.STATUS_FAILURE)),
    onError,
  );

  session.begin();

  if (onCancel) {
    session.oncancel = onCancel;
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/applePay.js